import { axiosApi } from "shared/api/axios";
import { MethodPayments } from "../types";

export const GetMethodPayment = async (): Promise<MethodPayments[]> => {
    try {
        const url = `${process.env.API_BACKEND}/v1/payments/payment/methods`;
        const response = await axiosApi.get<MethodPayments[]>(url);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};